module.exports = __webpack_public_path__ + "assets/img/presentation.9054582c.webp";